import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, useLocation, useNavigate } from 'react-router-dom';
import LoginPage from './Component/Loginpages';
import AdminRoutes from './Component/layout/Admin/routesAdmin';

function AppContent() {
  const navigate = useNavigate();
  const location = useLocation();
  const isLoginPage = location.pathname === '/login';
  const [admin, setAdmin] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let parsedAdmin = null;

    const savedAdmin = localStorage.getItem('admin_user');
    if (savedAdmin) {
      try {
        parsedAdmin = JSON.parse(savedAdmin);
        setAdmin(parsedAdmin);
      } catch (e) {
        localStorage.removeItem('admin_user');
      }
    }

    setIsLoading(false);
  }, []);

  useEffect(() => {
    if (isLoading) return;

    if (!admin && !isLoginPage) {
      navigate('/login', { replace: true });
      return;
    }

    if (admin && isLoginPage) {
      navigate('/', { replace: true });
    }
  }, [admin, isLoading, isLoginPage, navigate]);

  const handleAdminLogin = (adminData) => {
    setAdmin(adminData);
  };

  const handleAdminLogout = () => {
    localStorage.removeItem('admin_user');
    setAdmin(null);
    navigate('/login', { replace: true });
  };

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-600"></div>
      </div>
    );
  }

  return (
    <div className="App">
      {admin ? (
        <AdminRoutes admin={admin} onLogout={handleAdminLogout} />
      ) : isLoginPage ? (
        <LoginPage
          onAdminLogin={handleAdminLogin}
          onGoToHome={() => navigate('/')}
        />
      ) : null}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
